import useModal from "../../../useModal";
import UseContext from "../../../../../hooks/useContext";
import Modalheader from "../../../components/header";
import React, {useState} from "react";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import ModalBody from "../../../components/body";
import {toast} from "react-toastify";
import StyledInput from "../../../../styledInput/StyledInput";

const DELETE_OPTIONS = [
    {value: 'thisDay', labelKey: 'deleteThisDay', defaultLabel: 'Cette journée'},
    {value: 'thisDayAndOthers', labelKey: 'deleteThisDayAndNext', defaultLabel: 'Cette journée et toutes les suivantes aux mêmes périodes'},
    {value: 'allSame', labelKey: 'deleteAllSame', defaultLabel: 'Toutes les journées aux mêmes périodes'},
]

const DeleteScheduleWeekDay = () => {
    const {toggle}=useModal()
    const {activeScheduleWeekDay, setActiveScheduleWeekDay, setData, data, handleNext, updSchedule, setUpdSchedule, language} = UseContext()
    const [selectDeleteOption, setSelectDeleteOption] = useState('thisDay')

    const handleSubmit = (e) => {
        e.preventDefault()

        if(selectDeleteOption !== '' && activeScheduleWeekDay){
            let validDeleteOption = false
            const activeDate = data.schedule[activeScheduleWeekDay[0]].days[activeScheduleWeekDay[1]].date
            const activePeriods = data.schedule[activeScheduleWeekDay[0]].days[activeScheduleWeekDay[1]].periods

            if(selectDeleteOption === 'thisDay'){
                validDeleteOption = true;

                for (let i = 0; i < data.schedule.length; i++) {
                    for (let j = 0; j < data.schedule[i].days.length; j++) {
                        if(data.schedule[i].days[j].date === activeDate) {
                            delete data.schedule[i].days[j].periods;
                        }
                    }
                }
            } else if (selectDeleteOption === 'thisDayAndOthers'){
                validDeleteOption = true;

                for (let i = 0; i < data.schedule.length; i++) {
                    for (let j = 0; j < data.schedule[i].days.length; j++) {
                        if(data.schedule[i].days[j].date >= activeDate){
                            if(data.schedule[i].days[j].periods) {
                                if (
                                    data.schedule[i].days[j].periods.periode_one_start === activePeriods.periode_one_start &&
                                    data.schedule[i].days[j].periods.periode_one_end === activePeriods.periode_one_end &&
                                    data.schedule[i].days[j].periods.periode_two_start === activePeriods.periode_two_start &&
                                    data.schedule[i].days[j].periods.periode_two_end === activePeriods.periode_two_end &&
                                    data.schedule[i].days[j].periods.periode_three_start === activePeriods.periode_three_start &&
                                    data.schedule[i].days[j].periods.periode_three_end === activePeriods.periode_three_end
                                ) {
                                    delete data.schedule[i].days[j].periods;
                                }
                            }
                        }
                    }
                }
            } else if (selectDeleteOption === 'allSame'){
                validDeleteOption = true;

                for (let i = 0; i < data.schedule.length; i++) {
                    for (let j = 0; j < data.schedule[i].days.length; j++) {
                        if(data.schedule[i].days[j].periods){
                            if(
                                data.schedule[i].days[j].periods.periode_one_start === activePeriods.periode_one_start &&
                                data.schedule[i].days[j].periods.periode_one_end === activePeriods.periode_one_end &&
                                data.schedule[i].days[j].periods.periode_two_start === activePeriods.periode_two_start &&
                                data.schedule[i].days[j].periods.periode_two_end === activePeriods.periode_two_end &&
                                data.schedule[i].days[j].periods.periode_three_start === activePeriods.periode_three_start &&
                                data.schedule[i].days[j].periods.periode_three_end === activePeriods.periode_three_end
                            ){
                                delete data.schedule[i].days[j].periods;
                            }
                        }
                    }
                }
            } else {
                toast.error('Veuillez choisir une option de suppression')
            }

            if(validDeleteOption){
                data.isConfirmedSchedule = false
                setUpdSchedule(true)
                toggle()
            }
        }
        else{
            toast.error('Veuillez choisir une option de suppression')
        }
    }

    return (
        <>
            <Modalheader hide={toggle} hideShow={true} closeLabel={language.getValue('missionCreation.modal.close', 'Fermer')}>
                Effacer une journée
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <div className={'flex flex-col gap-3'}>
                    {DELETE_OPTIONS.map((option) => (
                        <StyledInput
                            key={option.value}
                            type={'radio'}
                            label={language.getValue(`missionCreation.scheduleForm.${option.labelKey}`, option.defaultLabel)}
                            checked={selectDeleteOption === option.value}
                            onChange={() => setSelectDeleteOption(option.value)}
                        />
                    ))}
                </div>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={'LG'} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
}

export default DeleteScheduleWeekDay;
